import { actionCreator, selectors } from '@/store/messaging';
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	LinearProgress
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

export const DialogManager = () => {
	const dispatch = useDispatch();
	const dialog = useSelector(selectors.getNextDialog);
	if (dialog === null || dialog === undefined) return null;

	const handleOk = () => {
		dispatch(dialog.okAction);
		dispatch(actionCreator.DISMISS_DIALOG(dialog.id));
	};

	const handleCancel = () => {
		if (dialog.cancelAction !== null) {
			dispatch(dialog.cancelAction);
		}
		dispatch(actionCreator.DISMISS_DIALOG(dialog.id));
	};
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const handleClose = (event: any, reason: string) => {
		if (reason === 'backdropClick') {
			return;
		}
	};

	return (
		<Dialog
			fullWidth
			maxWidth={'md'}
			onClose={handleClose}
			disableEscapeKeyDown
			open={true}>
			<DialogTitle>{dialog.title}</DialogTitle>
			<DialogContent>
				<DialogContentText
					sx={{
						display: 'flex',
						alignItems: 'center'
					}}>
					{dialog.message}
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button
					onClick={handleOk}
					color='primary'
					variant='contained'>
					Ok
				</Button>
				{dialog.allowCancel && (
					<Button
						onClick={handleCancel}
						color='primary'
						variant='text'>
						Cancel
					</Button>
				)}
			</DialogActions>
		</Dialog>
	);
};

export const MessageManager = () => {
	const dispatch = useDispatch();
	const message = useSelector(selectors.getNextMessage);
	if (message === null || message === undefined) return null;
	const handleClose = () => {
		dispatch(actionCreator.DISMISS_MESSAGE(message.id));
	};

	return (
		<Dialog
			fullWidth
			maxWidth={'md'}
			onClose={handleClose}
			open={true}>
			<DialogTitle>{message.title}</DialogTitle>
			<DialogContent>
				<DialogContentText
					sx={{
						display: 'flex',
						alignItems: 'center',
						fontSize: message.largeText ? '3em' : 'unset'
					}}>
					{message.message}
				</DialogContentText>
				{message.data && (
					<DialogContentText
						sx={{
							display: 'flex',
							alignItems: 'center'
						}}>
						{message.data}
					</DialogContentText>
				)}
			</DialogContent>
			<DialogActions>
				<Button
					onClick={handleClose}
					color='primary'
					variant='contained'>
					Ok
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export const ProgressManager = () => {
	const progress = useSelector(selectors.getProgress);
	if (progress === null || progress === undefined) return null;

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const handleClose = (event: any, reason: string) => {
		if (reason === 'backdropClick') {
			return;
		}
	};

	return (
		<Dialog
			fullWidth
			maxWidth={'md'}
			key={progress.id}
			onClose={handleClose}
			disableEscapeKeyDown
			open={true}>
			<DialogContent>
				<DialogContentText
					sx={{
						display: 'flex',
						alignItems: 'center'
					}}>
					{progress.title}
					{progress.value !== 0 &&
						`${(progress.value * 100).toFixed(0)}%`}
				</DialogContentText>
				{progress.value === 0 && (
					<LinearProgress variant='indeterminate' />
				)}
				{progress.value > 0 && (
					<LinearProgress
						variant='determinate'
						value={progress.value * 100.0}
					/>
				)}
			</DialogContent>
		</Dialog>
	);
};
